module.exports = __webpack_public_path__ + "a89ee58fe54bbf3cebd89767b1039c97.svg";